import type { GetServerSidePropsContext } from 'next';
import { useConfig } from 'shared/config/ConfigContext';
import { Head } from 'shared/page/Head';
import type { DeviceType } from 'shared/types';
import { ResultMap } from '@/scenes/resultPage/ResultMap';
import { clientConfig } from '@/server/config';
import { buildCommonProps, sanitizeCommonProps } from '@/server/middleware';

interface MapPageProps {
    loginId?: number;
    deviceType?: DeviceType;
    [key: string]: unknown;
}

const MapPage = (props: MapPageProps) => {
    const { baseUrl } = useConfig();

    return (
        <>
            <Head
                title="Feriehjem og hytter - sammenlign pris | FINN reise"
                description="Finn tusenvis av feriehjem og hytter på et sted!"
                canonical={`${baseUrl}/reise/feriehus-hytteutleie/kart/`}
            />
            <main>
                {/* @ts-expect-error ResultMap HOC props typing */}
                <ResultMap {...props} />
            </main>
        </>
    );
};

export const getServerSideProps = async ({ req, res, query }: GetServerSidePropsContext) => {
    const commonProps = await buildCommonProps(req, res, query);

    return {
        props: {
            config: clientConfig,
            ...sanitizeCommonProps(commonProps),
        },
    };
};
export default MapPage;
